import './ModalTemplate.scss';

import { Button, Modal, ModalBody } from 'react-bootstrap';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface OwnProps {
  onClose: () => void;
  text: string;
  subtext?: string;
  confirmBtn: any;
  isLoading?: boolean;
}

const ModalTemplate = (props: OwnProps) => {
  const intl = useIntl();

  return (
    <Modal
      className="modal-template"
      show
      onHide={props.onClose}
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton />
      <ModalBody>
        <h3 dangerouslySetInnerHTML={{ __html: props.text }} />
        {props.subtext && (
          <p dangerouslySetInnerHTML={{ __html: props.subtext }} />
        )}
        <div className="wrapper-btn">
          <Button
            variant="secondary"
            onClick={props.onClose}
            disabled={props.isLoading}
          >
            {intl.formatMessage({ ...siteMessages.cancel })}
          </Button>
          {props.confirmBtn}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalTemplate;
